<template lang="pug">
.navbar-section
  .loading.loading-lg.flex-centered(v-if='loading')
  .d-flex.align-center(v-else-if='user')
    qr-code(:active="qrOpened" v-if="filiationURL" :link="filiationURL" @close="qrOpened = false")
    router-link.btn.btn-sm.btn-action.btn-link.text-error.tooltip.tooltip-left(v-if="filiationURL" :to="{ name: 'help.filiations.link', query: { ref: 'link' } }" data-tooltip="O que é este link?")
      i.fas.fa-question
    .input-group.hide-md.mr-2(v-if='user.filiation')
      span.input-group-addon.addon-sm Seu link
      .text-ellipsis.form-input.input-sm {{ filiationURL }}
      button.btn.btn-primary.input-group-btn.btn-sm.tooltip.tooltip-bottom(
        data-tooltip='Copiar',
        @click='copyFiliationURL'
      )
        i.fas.fa-clipboard
      button.btn.btn-link.input-group-btn.btn-sm.tooltip.tooltip-bottom.ml-2(
        data-tooltip='QR code',
        @click='qrOpened = true'
      )
        i.fas.fa-qrcode
    .dropdown.dropdown-right.d-flex
      .loading.loading-lg.avatar-lg(v-if='loading')
      a.btn.btn-link.flex-centered.dropdown-toggle(v-else tabindex="0")
        .d-flex.align-center
          div
            user-avatar(:user='user')
          .ml-2.text-bold.text-ellipsis {{ user.fullName.split(" ")[0] }}
        i.fas.fa-caret-down.ml-2
      ul.menu
        li
          .columns.align-center.text-ellipsis
            .column.col-auto
              user-avatar.avatar-lg(:user='user')
            .column.text-ellipsis
              .text-ellipsis
                .text-ellipsis.text-bold {{ user.fullName }}
                small.text-ellipsis {{ user.email }}
        li.divider
        li.menu-item
          a.c-hand.text-error(@click='handleLogout')
            i.fas.fa-fw.fa-sign-out-alt
            span.label-signout &nbsp;Sair
</template>

<script>
import UserAvatar from '../helpers/UserAvatar'
import { mapState, mapActions } from 'vuex'
import env from '@/config/env'
import QrCode from './QrCode.vue'

export default {
  data() {
    return { qrOpened: false }
  },
  computed: {
    ...mapState('auth', ['user', 'loading']),
    filiationURL() {
      if (!this.user.filiation) return ''
      const url = env.storeURL
      return `${url}?filiation=${this.user.filiation.code}`
    },
  },
  components: { UserAvatar, QrCode },
  methods: {
    ...mapActions('auth', ['logout']),
    async copyFiliationURL() {
      await navigator.clipboard.writeText(this.filiationURL)
      this.$toaster.success('Link copiado')
    },
    async handleLogout() {
      await this.logout()
      this.$router.replace({ name: 'auth.login' })
    },
  },
}
</script>

<style lang="stylus" scoped>
.input-group
  .form-input
    max-width 190px
.menu
  min-width 250px
</style>
